<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content ">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"  title=" Our Vision" subtitle="  Our Vision" ></app-page-banner>
       <div class="container pt-2 pb-5">        
        <div class="row align-items-center ">
            <!-- Left Side: Image -->
            <div class="col-lg-6 col-md-12 m-b10">
                <div class="image-container text-center mt-5 mb-5 pl-0">
                    <img src="assets/images/thumbnail_beautiful-alstroemeria-flowers.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                </div>
            </div>
        
            <!-- Right Side: Text Content -->
            <div class="col-lg-6 col-md-12">
                <div class="text-content mobcontent" style="position: relative;bottom: 155px;">
                    <div class="separator-line mb-4 mobcontene"></div>
                    <p >We envision a world where individuals have access to supportive and integrative
                        care that nurtures mind, body, and spirit, empowering them to lead fulfilling lives.</p>
                         
                    
                </div>
            </div>
        </div>
        
        </div>
              

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>


